import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AccountHeadMaster = () => {
    const outlateId = JSON.parse(localStorage.getItem("SelectedOutlet"))?.outlate_id;
    
    const initialState = {
        outletId: outlateId,
        MainAc_Id: "",
        SubAc_Id: "",
        SubSubAc_Id: "",
        AccountName: "",
        IsOutlet: true
    };

    const [accountsheadardata, setAccountsheadardata] = useState([]);
    const [accounts, setAccounts] = useState(initialState);
    const [isEditable, setIsEditable] = useState(false);
    const [editId, setEditId] = useState(null); // <-- track if editing existing
   const [mainAcId ,setMainAc_Id] = useState()
   const [subAcId ,setSubAc_Id] = useState()
   const [subSubAcId ,setSubSubAc_Id] = useState()
   

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAccounts(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRadioChange = (e) => {
        const value = e.target.value === 'true';
        setAccounts(prev => ({
            ...prev,
            IsOutlet: value
        }));
    };

    const handleClear = () => {
        setAccounts({ ...initialState });
        setIsEditable(false);
        setEditId(null);
    };

    const handleAdd = () => {
        setAccounts({
            ...initialState,
            outletId: outlateId,
            MainAc_Id: accounts.MainAc_Id,
            SubAc_Id: accounts.SubAc_Id,
            SubSubAc_Id: accountsheadardata.length+1,
            AccountName: "",
            IsOutlet: accounts.IsOutlet
         });
        setIsEditable(true);
        setEditId(null);
        //setNextSubSubId(accountsheadardata.length+1);
    };

    const fetchData = async () => {
        try {
            const resp = await axios.get(`${process.env.REACT_APP_SERVER_API}account-head/${outlateId}/${accounts.MainAc_Id}/${accounts.SubAc_Id}`);
            setAccountsheadardata(resp.data);
          
            console.log("Data fetched successfully");
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };

    

    const handleSave = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_SERVER_API}account-head`, accounts);
            alert("Saved successfully!");
            fetchData();
        } catch (err) {
            console.error("Error saving:", err);
            alert("Failed to save.");
        }
    };

    const handleRowClick = (item) => {
        setAccounts(item);
        setIsEditable(true);
        setMainAc_Id(item.MainAc_Id);
        setSubAc_Id(item.SubAc_Id);
        setSubSubAc_Id(item.SubSubAc_Id);
    };

    const handleUpdate = async () => {
        try {
            const updatedData = {
                ...accounts,
                IsOutlet: Boolean(accounts.IsOutlet) // Ensure it's boolean
            };


            await axios.put(`${process.env.REACT_APP_SERVER_API}account-head/${outlateId}/${mainAcId}/${subAcId}/${subSubAcId}`, updatedData);
            alert("Updated successfully!");
            fetchData();
        } catch (err) {
            console.error("Error updating:", err);
            alert("Failed to update.");
        }
    };

    return (
        <div className="container-fluid p-3">
            <div className="row border p-3">
                <div className="col-md-6">
                    <div className='row'>
                        <div className='col-3'>
                            <div className="d-flex">
                                <label className='me-2'>Main A/c</label>
                                <input type="text" className="form-control" 
                                    name="MainAc_Id" style={{width: "60px", height: "25px"}} 
                                    value={accounts.MainAc_Id} onChange={handleChange}
                                     />
                            </div>
                        </div>
                        <div className='col-3'>
                            <div className="d-flex">
                            <label className='me-2'>Sub A/c</label>
                                <input type="text" className="form-control" 
                                    name="SubAc_Id" style={{width: "60px", height: "25px"}}
                                    value={accounts.SubAc_Id} onChange={handleChange}
                                     />
                            </div>
                        </div>
                        <div className='col-2'>
                            <button className='btn btn-primary'
                             style={{width: "60px", height: "25px", lineHeight: "13px"}}
                             onClick={fetchData}
                            >
                                show
                            </button>

                        </div>
                        <div className='col-4'>
                            <div className="d-flex">
                            <label className='me-2'>Sub-Sub A/c</label>
                                <input type="text" className="form-control" 
                                    name="SubSubAc_Id" style={{width: "60px", height: "25px"}}
                                    value={accounts.SubSubAc_Id} onChange={handleChange}
                                     />
                            </div>
                        </div>
                    </div>

                    <div className="mt-3">
    <label className="form-label">
        {accounts.MainAc_Id === "1" && "Assets A/c Name"}
        {accounts.MainAc_Id === "2" && "Liabilities A/c Name"}
        {accounts.MainAc_Id === "3" && "Income A/c Name"}
        {accounts.MainAc_Id === "4" && "Expenses A/c Name"}
    </label>
    <input
        type="text"
        className="form-control"
        placeholder="Enter A/c Name"
        name="AccountName"
        value={accounts.AccountName}
        onChange={handleChange}
        disabled={!isEditable}
    />
</div>


                    <div className="mt-3">
                        <label className="form-label me-3">Account for Outlet?</label>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="IsOutlet" id="outletNo"
                                value={false} checked={!accounts.IsOutlet} onChange={handleRadioChange}
                                disabled={!isEditable} />
                            <label className="form-check-label" htmlFor="outletNo">No</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="IsOutlet" id="outletYes"
                                value={true} checked={accounts.IsOutlet} onChange={handleRadioChange}
                                disabled={!isEditable} />
                            <label className="form-check-label" htmlFor="outletYes">Yes</label>
                        </div>
                    </div>

                    <div className="d-flex gap-2 mt-3">
                        <button className="btn btn-primary" onClick={handleAdd}>Add</button>
                        <button className="btn btn-success" onClick={handleSave} disabled={!isEditable || editId !== null}>Save</button>
                        <button className="btn btn-warning" onClick={handleUpdate} disabled={!isEditable }>Update</button>
                        <button className="btn btn-info text-white" onClick={handleClear}>Clear</button>
                    </div>
                </div>

                <div className="col-md-6">
                    <table className='table table-bordered'>
                        <thead className='bg-light sticky-top'>
                            <tr>
                                <th>AccountName</th>
                                <th>IsOutlet</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountsheadardata.map((item) => (
                                <tr key={item.AccountsHeaderId} onClick={() => handleRowClick(item)} style={{ cursor: 'pointer' }}>
                                    <td className='border'>{item.AccountName}</td>
                                    <td className='border'>{item.IsOutlet ? 'Yes' : 'No'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AccountHeadMaster;
